var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseholdActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2536",
    "data-name": "Rectangle 2536",
    width: 16,
    height: 12,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13688",
    "data-name": "Group 13688",
    transform: "translate(-43 -205)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3228",
    "data-name": "Rectangle 3228",
    width: 18,
    height: 18,
    transform: "translate(43 205)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6675",
    "data-name": "Group 6675",
    transform: "translate(44 208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6673",
    "data-name": "Group 6673",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25742",
    "data-name": "Path 25742",
    d: "M0,6A1.652,1.652,0,0,1,.2,5.78Q3.669,3.051,7.145.326a1.283,1.283,0,0,1,1.712,0q1.086.853,2.169,1.708c.039.031.08.06.142.106,0-.068.009-.114.009-.16,0-.52,0-1.04,0-1.56,0-.3.1-.393.423-.394q.851,0,1.7,0c.3,0,.413.1.413.392,0,1.192,0,2.384,0,3.576a.278.278,0,0,0,.125.247c.652.5,1.3,1.014,1.948,1.521.264.207.279.348.061.593-.16.18-.32.362-.482.541a.359.359,0,0,1-.564.046L8.2,1.763,8,1.6l-.743.582L1.21,6.936a.366.366,0,0,1-.587-.047C.414,6.653.207,6.415,0,6.177V6",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25743",
    "data-name": "Path 25743",
    d: "M58.093,59.209l2.641,2.05q1.476,1.146,2.954,2.291a.28.28,0,0,1,.123.249q-.005,2.148,0,4.3a.638.638,0,0,1-.724.685q-1.781,0-3.562,0c-.046,0-.092,0-.154-.007V65.2H56.823v3.571c-.073,0-.123.007-.174.007q-1.773,0-3.546,0a.64.64,0,0,1-.729-.7c0-1.427,0-2.855,0-4.282a.294.294,0,0,1,.131-.26q2.721-2.106,5.436-4.219c.048-.037.1-.072.155-.116",
    transform: "translate(-50.091 -56.781)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseholdActive);
export default __webpack_public_path__ + "static/media/household-active.d94a50e37d31c401744cbdad8ff3da92.svg";
export { ForwardRef as ReactComponent };